import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import * as actionCreators from "./actionCreators"
import { CommonState } from "./reducer"
import { useSelector } from "react-redux"
import { State } from "../../../state"

export const useCommonState = (): CommonState => useSelector((state: State) => state.commonReducer)

export const useCommonStateActions = () => bindActionCreators(actionCreators, useDispatch())
